import { render, staticRenderFns } from "./ModalViewPDF.vue?vue&type=template&id=3482d68c&scoped=true&"
import script from "./ModalViewPDF.vue?vue&type=script&lang=ts&"
export * from "./ModalViewPDF.vue?vue&type=script&lang=ts&"
import style0 from "./ModalViewPDF.vue?vue&type=style&index=0&id=3482d68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3482d68c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3482d68c', component.options)
    } else {
      api.reload('3482d68c', component.options)
    }
    module.hot.accept("./ModalViewPDF.vue?vue&type=template&id=3482d68c&scoped=true&", function () {
      api.rerender('3482d68c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/Capacitaciones/ModalViewPDF.vue"
export default component.exports